// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"castle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6 5H18C18 10.3333 18 15.6667 18 21H6V5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M14 14H10V21H14V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M2 21H6V15H2V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M18 21H22V15H18V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M14 14H10V21H14V14Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M2 15V21H6V15H2ZM2 15V14M22 15V21H18V15H22ZM22 15V14M10 14H14V21H10V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M18 5V3M18 5H14M18 5C18 10.3333 18 15.6667 18 21H6V5M6 5V3M6 5H10M10 3V5M10 5H14M14 3V5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-castle')
export default class CastleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle',
    }
  }
}
